/* eslint-disable react/prop-types */
import CmdKGroup from 'src/components/Cmdk/CmdKGroup'
import AirplanemodeActiveRoundedIcon from '@mui/icons-material/AirplanemodeActiveRounded'
import CommandItem from 'src/components/Cmdk/CmdKItem'
import { filter } from 'src/components/Cmdk/filter'
import CmdkSubMenu from 'src/components/Cmdk/CmdkSubMenu'
import { CommandMenuGroup } from 'src/components/Cmdk/Cmdk'
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded'
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded'
import FilterListOffRoundedIcon from '@mui/icons-material/FilterListOffRounded'
import LooksIcon from 'src/components/LooksIcon'
import dayjs from 'dayjs'
import useMaintenanceItemTable from 'src/hooks/useMaintenanceItemTable'
import useAircraftList from 'src/hooks/requests/useAircraftRecords'
import { useEffect } from 'react'
import { useOrgName } from 'src/hooks/useOrgName'

export interface CmdkDueListPageModuleProps extends Record<string, unknown> {
  search?: string
  pages?: CommandMenuGroup[][]
  onNavigate?: (groups: CommandMenuGroup[]) => void
  onBack?: () => void
  onClose?: () => void
}

const CmdkDueListPageModule: React.FC<CmdkDueListPageModuleProps> = ({
  search,
  pages,
  onNavigate,
  onBack,
  onClose,
}) => {
  const {
    duelistFiltersData: filterData,
    setDueListFilterPopoverFilters,
    setAircraftFilter,
    resetFilters,
  } = useMaintenanceItemTable('duelist')

  const orgSlug = useOrgName()

  const { loadAircraftList, aircrafts } = useAircraftList()

  useEffect(() => {
    loadAircraftList({ orgSlug })
  }, [])

  const items = [
    {
      label: 'Clear Projections',
      keywords: ['clear', 'projections', 'filter'],
      startIcon: <FilterListOffRoundedIcon />,
      onSelect: () => {
        resetFilters()
        onClose?.()
      },
    },
  ]

  const filterByAircraftItems = Object.values(aircrafts).map((aircraft) => ({
    label: aircraft.tailNumber,
    keywords: [aircraft.tailNumber, 'filter'],
    startIcon: <AirplanemodeActiveRoundedIcon />,
    onSelect: () => {
      setAircraftFilter(aircraft.id, true)
      onClose?.()
    },
  }))

  const filterByDateItems = [
    {
      label: '30 days',
      keywords: ['30', 'days', 'filter'],
      startIcon: <LooksIcon value="30" />,
      onSelect: () => {
        const next = dayjs().add(30, 'day')

        setDueListFilterPopoverFilters({
          projections: {
            ...filterData.projectionFilterData,
            date: next.toISOString(),
          },
          generalFilters: filterData.generalFilterData,
          ataCodes: filterData.ataCodes,
          trackedBy: filterData.trackedBy,
        })
        onClose?.()
      },
    },
    {
      label: 'three months',
      keywords: ['3', 'three', 'months', 'filter'],
      startIcon: <LooksIcon value="3" />,
      onSelect: () => {
        const next = dayjs().add(3, 'month')

        setDueListFilterPopoverFilters({
          projections: {
            ...filterData.projectionFilterData,
            date: next.toISOString(),
          },
          generalFilters: filterData.generalFilterData,
          ataCodes: filterData.ataCodes,
          trackedBy: filterData.trackedBy,
        })
        onClose?.()
      },
    },
    {
      label: 'six months',
      keywords: ['6', 'six', 'months', 'filter'],
      startIcon: <LooksIcon value="6" />,
      onSelect: () => {
        const next = dayjs().add(6, 'month')

        setDueListFilterPopoverFilters({
          projections: {
            ...filterData.projectionFilterData,
            date: next.toISOString(),
          },
          generalFilters: filterData.generalFilterData,
          ataCodes: filterData.ataCodes,
          trackedBy: filterData.trackedBy,
        })
        onClose?.()
      },
    },
    {
      label: 'twelve months',
      keywords: ['12', 'twelve', 'months', 'filter'],
      startIcon: <LooksIcon value="12" />,
      onSelect: () => {
        const next = dayjs().add(12, 'month')

        setDueListFilterPopoverFilters({
          projections: {
            ...filterData.projectionFilterData,
            date: next.toISOString(),
          },
          generalFilters: filterData.generalFilterData,
          ataCodes: filterData.ataCodes,
          trackedBy: filterData.trackedBy,
        })
        onClose?.()
      },
    },
  ]

  const filteredItems = items.filter((item) =>
    filter(item.label, search, item.keywords)
  )

  // if (filteredItems.length === 0) return null

  return (
    <CmdKGroup heading={pages?.length === 0 ? 'Due List Page' : ''}>
      <CmdkSubMenu
        parentLabel="Filter By Date"
        parentStartIcon={<CalendarMonthRoundedIcon />}
        items={filterByDateItems}
        pages={pages}
        search={search}
        onNavigate={onNavigate}
        onBack={onBack}
      />
      <CmdkSubMenu
        parentLabel="Filter By Aircraft"
        parentStartIcon={<AirplanemodeActiveRoundedIcon />}
        items={filterByAircraftItems}
        pages={pages}
        search={search}
        onNavigate={onNavigate}
        onBack={onBack}
      />
      {pages?.length === 0 &&
        filteredItems.map((item) => (
          <CommandItem
            key={item.label}
            onSelect={item.onSelect}
            keywords={item.keywords}
            startIcon={item.startIcon}
          >
            {item.label}
          </CommandItem>
        ))}
    </CmdKGroup>
  )
}

export default CmdkDueListPageModule
